import type { Quotation, QuotationExportSnapshot } from "../model";
import { calculateQuotationTotals } from "../totals";
import { assertQuotationCanExport } from "../validation";

function deepFreeze<T>(value: T): T {
  if (typeof value !== "object" || value === null || Object.isFrozen(value)) {
    return value;
  }

  Object.freeze(value);
  for (const child of Object.values(value)) {
    deepFreeze(child);
  }
  return value;
}

export function createQuotationExportSnapshot(
  quotation: Quotation,
  now = new Date(),
): QuotationExportSnapshot {
  assertQuotationCanExport(quotation);

  const normalizedQuotation = structuredClone(quotation);
  const snapshot: QuotationExportSnapshot = {
    snapshotVersion: 1,
    createdAt: now.toISOString(),
    quotation: normalizedQuotation,
    totals: calculateQuotationTotals(normalizedQuotation),
  };

  return deepFreeze(snapshot);
}
